import { EcommExclamationMarkCircleIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';

import { RefundStyles } from './Refund.styles';

type RefundProps = {
  message: string;
  shouldShow: boolean;
};

export const Refund = ({ message, shouldShow }: RefundProps) => {
  if (!shouldShow) {
    return null;
  }
  return (
    <RefundStyles.RefundWrapper direction='row' gap='$2'>
      <div>
        <EcommExclamationMarkCircleIcon color='$alert-standard' />
      </div>
      <div>
        <ResponsiveFloraTypography as='p' fontSize='bodySmallStandard' fontWeight='bold'>
          Reembolso
        </ResponsiveFloraTypography>
        <ResponsiveFloraTypography
          fontSize='bodySmallStandard'
          fontWeight='regular'
          color='$nonInteractiveAuxiliar'
        >
          {message}
        </ResponsiveFloraTypography>
      </div>
    </RefundStyles.RefundWrapper>
  );
};
